import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, mergeProps as _mergeProps, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  class: "bg-gray-400 bg-opacity-50 flex fixed w-full h-screen items-center justify-center",
  style: { 'top': '0px', 'left': '0px' }
}
const _hoisted_2 = { class: "flex flex-col modal-box w-96" }
const _hoisted_3 = { class: "flex justify-end w-full" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("svg", {
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M1 11L11 1",
    stroke: "#222B45",
    "stroke-width": "1.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M1 1L11 11",
    stroke: "#222B45",
    "stroke-width": "1.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "flex flex-col gap-4 p-2 w-full" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "flex justify-center w-full" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-title" }, "Add Table")
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "text-center text-small" }, "Each table need to be assigned to a Table Category.", -1)
const _hoisted_9 = {
  id: "table",
  class: "flex flex-row form-filter",
  style: { 'align-items': 'center' }
}
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "flex justify-end" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", null, "Add", -1)
const _hoisted_13 = [
  _hoisted_12
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AutoComplete = _resolveComponent("AutoComplete")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: "modal-button-close",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
        }, _hoisted_5)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _hoisted_8,
        _createElementVNode("div", _hoisted_9, [
          (_ctx.isSelected)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "absolute rounded-md bg-white p-2 shadow-lg w-48 z-20 custom-select",
                style: _normalizeStyle({ 'top': `${_ctx.totalHeight}px` })
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categories, ({
                            Name,
                        }, idx) => {
                  return (_openBlock(), _createElementBlock("option", _mergeProps({
                    class: "min-height list-link",
                    key: idx
                  }, _ctx.$attrs, {
                    onClick: ($event: any) => (_ctx.toggleSelect(), _ctx.addInputes(Name), _ctx.getStore())
                  }), _toDisplayString(Name), 17, _hoisted_10))
                }), 128))
              ], 4))
            : _createCommentVNode("", true),
          _createVNode(_component_AutoComplete, {
            items: _ctx.categories,
            "filter-by": "Name",
            "track-by": "Name",
            "show-by": "Name",
            class: "form-field w-full",
            placeholder: "Category",
            modelValue: _ctx.selectCategory,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectCategory) = $event))
          }, null, 8, ["items", "modelValue"])
        ]),
        _withDirectives(_createElementVNode("input", {
          type: "text",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.SaveTable.Name) = $event)),
          class: "form-field w-full"
        }, null, 512), [
          [_vModelText, _ctx.SaveTable.Name]
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", {
            class: "button",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.addTable && _ctx.addTable(...args)))
          }, _hoisted_13)
        ])
      ])
    ])
  ]))
}